import React, { useEffect } from "react";
import { connect } from "react-redux";

import IndexedDBService from "../../services/indexedDB/IndexedDB.service";
import appletSubgroupService from "./services/applet-subgroup.service";
import plateAction from "../../redux/actions/plateAction";

import AppletSubgroupType from "../../models/applet/applet-subgroup-type.entity";
import AppletSubgroups from "../../models/applet/applet-subgroup.entity";
import InspectionStepLocalDB from "../../models/indexedDB/inspection-step-local-db.entity";

import InspectionNative from "./Inspection.native";

import inspectionContentService from "./content/inspection-content.service";
import { StepsInterface } from "./interfaces/steps.interface";
import { useHistory } from "react-router-dom";
import InspectionDBStatus from "../../models/indexedDB/inspection-db-status.entity";
import locationService from "./services/location.service";
import inspectionService from "./services/inspection.service";
import inspectionEventService from "./services/inspection-event.service";
import { ProtectedRoute } from "../Auth/ProtectedRoute/ProtectedRoute ";
import PhotoLoader from "./components/CarLoader/PhotoLoader";
import PlateError from "./components/PlateError/PlateError";
import { classifyUploadError } from "./services/upload-error.util";

const InspectionContainer = (props: any) => {
  const history = useHistory();

  const [atualStepIndex, setAtualStepIndex] = React.useState<number>(0);
  // const [inspectionDb, setInspectionDb] = React.useState<InspectionStepLocalDB>(new InspectionStepLocalDB());

  const [atualSelectedPhoto, setAtualSelectedPhoto] = React.useState<any>({});

  const [isSaving, setIsSaving] = React.useState<boolean>(false);
  const [isOnline, setIsOnline] = React.useState<boolean>(true);
  const [uploadProgress, setUploadProgress] = React.useState<number>(0);
  const [showPlateError, setShowPlateError] = React.useState<boolean>(false);
  const [capturedSubgroupIds, setCapturedSubgroupIds] = React.useState<string[] | null>(null);

  // accessing redux props
  const plate = props.atualPlate;
  const atualUniqueID = props.atualUniqueID;
  const atualAppletProfileId = props.atualAppletProfileId;
  const atualVehicleData = props.atualVehicleData;

  const appletSubgroupType: AppletSubgroupType = appletSubgroupService.getAppleSubgroupList(atualAppletProfileId);

  const appletProfile = appletSubgroupType.profiles
    .find((type) => type.id === atualAppletProfileId);

  const appletSubgroups = appletProfile?.appletSubgroups || [];

  const atualAppletSubgroup: AppletSubgroups = appletSubgroups[atualStepIndex];
  const atualAppletStepContent: StepsInterface = inspectionContentService.getAtualAppletContent(atualAppletSubgroup);

  const query = new URLSearchParams(window.location.search);

  const isEdit = () => {
    const uniqueId = query.get('unique');
    const appletId = query.get('appletId');

    return (uniqueId && appletId);
  }

  const isResume = () => query.get('resume') === '1';

  const [isResolvingResume, setIsResolvingResume] = React.useState<boolean>(isResume());

  const getFirstMissingStepIndex = (capturedIds: string[]) => appletSubgroups
    .findIndex((appletSubgroup: AppletSubgroups) => !capturedIds.includes(appletSubgroup.id));

  const resumeInspection = () => {
    if (!atualUniqueID) {
      history.push('/first-step');
      return;
    }

    IndexedDBService.getByProperty('unique_identifier', atualUniqueID)
      .then((result: any) => {
        const capturedIds: string[] = result
          .map((item: any) => new InspectionStepLocalDB(item).appletSubgroupId);
        const firstMissingIndex = getFirstMissingStepIndex(capturedIds);

        if (firstMissingIndex === -1) {
          history.push('summary');
          return;
        }

        setCapturedSubgroupIds(capturedIds);
        setAtualStepIndex(firstMissingIndex);
        setIsResolvingResume(false);
      })
      .catch(() => {
        history.push('/first-step');
      });
  }

  const getAtualAppletSubgroup = () => {
    const uniqueId = query.get('unique');
    const appletId = query.get('appletId');

    if (uniqueId && appletId) {
      const appletToEditIndex = appletSubgroups
        .findIndex((appletSubgroup: AppletSubgroups) => appletSubgroup.id === appletId);
      setAtualStepIndex(appletToEditIndex);
    }
  }

  const grantedLocation = (pos: GeolocationPosition) => {
    saveLocalInspection(pos.coords);
  }

  const revokedLocation = (err: any) => {
    saveLocalInspection();
  }

  const getUserLocation = () => {
    locationService.getUserLocation(grantedLocation, revokedLocation);
  }

  const next = () => {
    if (capturedSubgroupIds) {
      const capturedIds = [...capturedSubgroupIds, atualAppletSubgroup.id];
      const nextMissingIndex = getFirstMissingStepIndex(capturedIds);

      setCapturedSubgroupIds(capturedIds);

      if (nextMissingIndex === -1) {
        history.push('summary');
        return;
      }

      setAtualStepIndex(nextMissingIndex);
      return;
    }

    if (appletSubgroups.length === (atualStepIndex + 1)) history.push('summary');
    setAtualStepIndex(atualStepIndex + 1);
  }

  const closePlateError = () => {
    setShowPlateError(false);
    history.push('/first-step');
  }

  const goToPanelWithVehicleError = () => {
    history.push('/first-step');
  }

  const uploadStepWhenOnline = (inspection: InspectionStepLocalDB): Promise<{ plateError: boolean; vehicleTypeError: boolean }> => new Promise((resolve) => {
    if (!window.navigator.onLine) {
      setTimeout(() => resolve({ plateError: false, vehicleTypeError: false }), 800);
      return;
    }

    setUploadProgress(0);

    const eventFormData: FormData = inspectionService
      .createdFormDataToInspectEvent(inspection);

    inspectionEventService.sendFormData(
      '/inspection-event-fleet-offline',
      eventFormData,
      (percent: string) => setUploadProgress(Number(percent)),
    ).then(() => {
      inspection.status = InspectionDBStatus.SENT;
      IndexedDBService.update(inspection.formatUpdatePayload());
      resolve({ plateError: false, vehicleTypeError: false });
    }).catch((error: any) => {
      const kind = classifyUploadError(error);

      if (kind === 'already-inspected') {
        inspection.status = InspectionDBStatus.SENT;
        IndexedDBService.update(inspection.formatUpdatePayload());
        resolve({ plateError: false, vehicleTypeError: false });
        return;
      }

      if (kind === 'rate-limited') {
        inspection.status = InspectionDBStatus.WAITING;
        IndexedDBService.update(inspection.formatUpdatePayload());
        resolve({ plateError: false, vehicleTypeError: false });
        return;
      }

      inspection.status = kind === 'recoverable'
        ? InspectionDBStatus.WAITING
        : InspectionDBStatus.WITH_ERROR;
      IndexedDBService.update(inspection.formatUpdatePayload());

      resolve({
        plateError: kind === 'validation',
        vehicleTypeError: kind === 'vehicle-type',
      });
    });
  });

  const saveLocalInspection = async (coords?: GeolocationCoordinates) => {
    setIsOnline(window.navigator.onLine);

    const inspection = new InspectionStepLocalDB();
    inspection.photo = atualSelectedPhoto;
    inspection.plate = plate;
    inspection.appletSubgroupId = atualAppletSubgroup.id;
    inspection.createDate = new Date().toString();
    inspection.status = window.navigator.onLine
      ? InspectionDBStatus.SENDING
      : InspectionDBStatus.WAITING;
    inspection.accuracy = coords?.accuracy || 0;
    inspection.longitude = coords?.longitude || 0;
    inspection.latitude = coords?.latitude || 0;
    inspection.appletProfileId = atualAppletProfileId;
    inspection.vehicleData = atualVehicleData || null;

    if (isEdit()) {
      const uniqueId = query.get('unique') || '';
      const id = query.get('id') || 0;
      inspection.uniqueIdentifier = uniqueId;
      inspection.id = +id;

      IndexedDBService.update(inspection.formatUpdatePayload());
      const editResult = await uploadStepWhenOnline(inspection);
      setIsSaving(false);
      if (editResult.vehicleTypeError) {
        goToPanelWithVehicleError();
        return;
      }
      if (editResult.plateError) {
        setShowPlateError(true);
        return;
      }
      history.push('summary');
      return;
    }

    inspection.uniqueIdentifier = atualUniqueID;
    const newId = await IndexedDBService.addData(inspection.formatPayload());
    inspection.id = Number(newId);

    const result = await uploadStepWhenOnline(inspection);

    setIsSaving(false);
    if (result.vehicleTypeError) {
      goToPanelWithVehicleError();
      return;
    }
    if (result.plateError) {
      setShowPlateError(true);
      return;
    }
    next();
  }

  const onChangePhoto = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e || !e.target || !e.target.files?.length) return;

    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (e: any) => {
      let bits = e.target.result;
      // ob is the data we save in the database/ indexedDB
      let ob = {
        created: new Date(),
        data: bits
      };

      setAtualSelectedPhoto(ob);
    }

    reader.readAsDataURL(file);
  }

  useEffect(() => {
    if (!Object.keys(atualSelectedPhoto).length) return;

    setUploadProgress(0);
    setIsOnline(window.navigator.onLine);
    setIsSaving(true);
    getUserLocation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [atualSelectedPhoto]);

  useEffect(() => {
    IndexedDBService.createdDB();
    getAtualAppletSubgroup();
    if (isResume()) resumeInspection();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ProtectedRoute>
      <>
        {!isResolvingResume && (
          <InspectionNative
            atualAppletStepContent={atualAppletStepContent}
            atualAppletSubgroup={atualAppletSubgroup}
            onChangePhoto={onChangePhoto}
            plate={plate}
            next={next}
          />
        )}
        <PhotoLoader
          open={isSaving}
          online={isOnline}
          progress={uploadProgress}
        />
        <PlateError
          open={showPlateError}
          onClose={closePlateError}
        />
      </>
    </ProtectedRoute>
  );
}

const mapStateToProps = (state: any) => ({
  ...state
});

const mapDispatchToProps = (dispatch: any) => ({
  plateAction: (payload: string) => dispatch(plateAction(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(InspectionContainer);
